import { selectProvider } from './authSelectors';
import { currentSessionHookless as backend } from './backend/backendAuthHookless';
import { currentSessionHookless as aws } from './useAwsAuth';

export const currentSessionHookless = (state) => {
  const provider = selectProvider(state);
  return provider === 'aws' ? aws() : backend(state);
};
